export default __webpack_public_path__ + "static/media/img.62d8580b.jpg";